export default "__VITE_ASSET__BuvW1VRv__"